<mat-card class="cardWithShadow">
  <mat-card-content>
    <div class="profile-container">
      <h2>Perfil do Funcionário</h2>
      <div class="profile-info">
        <p><strong>Nome do Funcionário:</strong> {{ funcionarioNome }}</p>
        <p><strong>Cargo:</strong> {{ cargo }}</p>
        <p><strong>Nome da Empresa:</strong>{{ cliente }}</p>
        @if (fazendas && fazendas.length > 0) {
          <p>
            <strong>Fazendas:</strong>
            @for (item of fazendas; track item; let last = $last) {
              <span>{{ item.nome }}</span
                >{{ !last ? ", " : "" }}
              }
            </p>
          }
          @if (!fazendas || fazendas.length === 0) {
            <p>
              <em>Nenhuma fazenda disponível.</em>
            </p>
          }
        </div>
        <button class="change-password-btn" (click)="changePassword()">
          Alterar Senha
        </button>
      </div>
    </mat-card-content>
  </mat-card>
